import React from 'react'
import marked from 'marked'
import DOMPurify from 'isomorphic-dompurify'

marked.setOptions({
  breaks: true
})

type MarkdownProps = {
  className?: string
  source?: string
}

const Markdown = ({ className, source }: MarkdownProps) => {
  const markup = { __html: DOMPurify.sanitize(marked(source || '')) }
  return <div className={className} dangerouslySetInnerHTML={markup} />
}

export default Markdown
